<template>
  <article class="layout-section__container">
    <h3 class="layout-section__heading -spacing">Smoothie</h3>

    <ul class="grid-icon">
      <li class="grid-icon__item">
        <svg-icon id="blender" />
      </li>

      <li class="grid-icon__item">
        <svg-icon id="smoothie-avocado" />
      </li>

      <li class="grid-icon__item">
        <svg-icon id="smoothie-blueberry" />
      </li>

      <li class="grid-icon__item">
        <svg-icon id="smoothie-bottle" />
      </li>

      <li class="grid-icon__item">
        <svg-icon id="smoothie-carrot" />
      </li>

      <li class="grid-icon__item">
        <svg-icon id="smoothie-mango" />
      </li>

      <li class="grid-icon__item">
        <svg-icon id="smoothie-melon" />
      </li>

      <li class="grid-icon__item">
        <svg-icon id="smoothie-nuts" />
      </li>

      <li class="grid-icon__item">
        <svg-icon id="smoothie-orange" />
      </li>

      <li class="grid-icon__item">
        <svg-icon id="smoothie-peach" />
      </li>

      <li class="grid-icon__item">
        <svg-icon id="smoothie" />
      </li>

      <li class="grid-icon__item">
        <svg-icon id="smoothie-spinach" />
      </li>


      <li class="grid-icon__item">
        <svg-icon id="smoothie-strawberry" />
      </li>

      <li class="grid-icon__item">
        <svg-icon id="smoothie-kiwi" />
      </li>

      <li class="grid-icon__item">
        <svg-icon id="smoothie-pear" />
      </li>

      <li class="grid-icon__item">
        <svg-icon id="smoothie-seeds" />
      </li>

      <li class="grid-icon__item">
        <svg-icon id="smoothie-milk" />
      </li>

      <li class="grid-icon__item">
        <svg-icon id="smoothie-apple" />
      </li>

      <li class="grid-icon__item">
        <svg-icon id="smoothie-banana" />
      </li>

      <li class="grid-icon__item">
        <svg-icon id="smoothie-pineapple" />
      </li>
    </ul>
  </article>
</template>

<script>
export default {
  name: 'WorkIconsSmoothie'
}
</script>
